<script>
import {useStore} from "@/helpers/store-effect";
import {useConnections} from "@/helpers/connections-effect";
import useLoading from "@/helpers/loading-effect";

export default {
  name: "ConnectionInitializer",
  template: '#connection-initializer-template',
  props: {
    provider: {type: String},
    compact: {type: Boolean, default: false},
  },
  emits: ['update:modelValue'],
  setup(props, {emit}) {
    const store = useStore();
    const connections = useConnections();

    const {
      isLoading,
      isLoaded,
      startLoading,
      stopLoading,
    } = useLoading(null);

    const connect = async () => {
      startLoading();
      try {
        const connection = await connections.connectWithProvider(props.provider);
      } finally {
        stopLoading();
      }
    };

    return {
      provider: props.provider,
      compact: props.compact,
      isLoading,
      connect
    }
  },
}
</script>
